<script>
import {onMounted, ref} from 'vue';
import {useMenuStore} from '@/js/store/MenuStore.js';
import {useCartStore} from '@/js/store/CartStore.js';
import {useLikeStore} from '@/js/store/LikeStore.js';
import IconLogo from '@js/components/Icons/IconLogo.vue';
import IconMapPoint from '@js/components/Icons/IconMapPoint.vue';
import IconAngleLeft from '@js/components/Icons/IconAngleLeft.vue';
import IconX from '@js/components/Icons/IconX.vue';
import IconChevronDown from '@js/components/Icons/IconChevronDown.vue';
import MobileMenuDropdownBlock from '@js/components/Mobile/Components/MobileMenuDropdownBlock.vue';
import SalesDepartmentPhone from '@js/components/Sections/Links/SalesDepartmentPhone.vue';
import {Link} from '@inertiajs/vue3';
import {useCompareStore} from "@js/store/CompareStore.js";
import OnlyMobile from "@js/components/DynamicComponents/OnlyMobile.vue";
import {usePopupsControlStore} from "@js/store/PopupsControlStore.js";
import IconUser from "@js/components/Icons/IconUser.vue";

export default {
    name: "MobileProfileMenu",
    components: {
        IconUser,
        OnlyMobile,
        IconLogo,
        IconMapPoint,
        IconAngleLeft,
        IconX,
        IconChevronDown,
        MobileMenuDropdownBlock,
        SalesDepartmentPhone,
        Link,
    },
    setup() {
        const menuStore = useMenuStore();
        const cartStore = useCartStore();
        const likeStore = useLikeStore();
        const compareStore = useCompareStore();
        const popupStore = usePopupsControlStore();

        // Для свайпа
        const touchStartX = ref(0);
        const touchDeltaX = ref(0);

        const onTouchStart = (e) => {
            touchStartX.value = e.touches[0].clientX;
        };
        const onTouchMove = (e) => {
            touchDeltaX.value = e.touches[0].clientX - touchStartX.value;
        };
        const onTouchEnd = () => {
            if (touchDeltaX.value < -50) {
                menuStore.toggleProfileSidenav();
            }
            touchDeltaX.value = 0;
        };

        const openCatalogMenu = () => {
            menuStore.toggleProfileSidenav()
            menuStore.toggleSidenav()
        }

        const openCitySelectPopup = () => {
            menuStore.toggleProfileSidenav()
            popupStore.showCitySelectPopup()
        }

        const isClient = ref(false);
        onMounted(() => {
            isClient.value = true;
        });

        return {
            isClient,
            menuStore,
            cartStore,
            likeStore,
            compareStore,
            popupStore,
            openCatalogMenu,
            onTouchStart,
            onTouchMove,
            onTouchEnd,
            openCitySelectPopup,
        };
    },
};
</script>

<template>
    <div>
        <div
            class="fixed inset-y-0 left-0 z-50 w-full max-w-[480px] bg-white shadow-lg transform transition-transform duration-300"
            :class="{
        '-translate-x-full': !menuStore.isProfileSidenavOpen,
        'translate-x-0': menuStore.isProfileSidenavOpen
      }"
            @touchstart.passive="onTouchStart"
            @touchmove.passive="onTouchMove"
            @touchend="onTouchEnd">
            <div class="flex flex-col h-full p-4">
                <div class="flex items-center justify-between mb-4">
                    <div>
                        <IconLogo class="h-auto w-[200px]"/>
                    </div>
                    <button @click.prevent="menuStore.toggleProfileSidenav" title="Закрыть" aria-label="Закрыть"
                            class="rounded-md focus:outline-none">
                        <IconX class="w-6 h-6"/>
                    </button>
                </div>
                <div class="flex items-center justify-between pb-8">
                    <a href="https://account.metallolom1-prokat.ru" target="_blank"
                          class="flex items-center justify-center w-full h-[44px] me-[8px] min-w-fit px-[16px] text-white bg-[#3ca241] md:hover:bg-[#3ca241]/80 rounded gap-1 font-semibold transition leading-tight">
                        <IconUser class="w-5 h-5 text-white"/>
                        Личный кабинет
                    </a>
                </div>
                <div class="overflow-auto">
                    <OnlyMobile>
                        <div class="flex flex-col gap-5 pb-8 border-b border-gray-200">
                            <div class="flex flex-col font-medium"
                                 @click.prevent="openCatalogMenu">
                                <div class="flex items-center justify-between">
                                    <div>
                                        Меню каталога
                                    </div>
                                    <div class="flex items-center gap-2">
                                        <IconAngleLeft class="w-5 h-5 rotate-180"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </OnlyMobile>
                    <div class="flex flex-col gap-5 max-md:mt-8 pb-8 border-b border-gray-200">
                        <div @click.prevent="openCitySelectPopup"
                             class="flex flex-col font-medium cursor-pointer"
                             v-if="popupStore.selectedCity.name">
                            <div class="flex items-center justify-between">
                                <div>
                                    Город
                                </div>
                                <div class="flex items-center gap-2">
                                    <IconMapPoint class="w-5 h-5 text-navHoverColor"/>
                                    {{ popupStore.selectedCity.name }}
                                    <IconAngleLeft class="w-5 h-5 rotate-180"/>
                                </div>
                            </div>
                        </div>
                        <Link :href="route('deliveryAndShipping')" class="flex flex-col font-medium">
                            <div class="flex items-center justify-between">
                                <div>
                                    Доставка
                                </div>
                                <div class="flex items-center gap-2">
                                    <IconAngleLeft class="w-5 h-5 rotate-180"/>
                                </div>
                            </div>
                        </Link>
                        <Link :href="route('aboutPayment')" class="flex flex-col font-medium">
                            <div class="flex items-center justify-between">
                                <div>
                                    Способы оплаты
                                </div>
                                <div class="flex items-center gap-2">
                                    <IconAngleLeft class="w-5 h-5 rotate-180"/>
                                </div>
                            </div>
                        </Link>
                    </div>
                    <div class="flex flex-col gap-5 mt-8 pb-8 border-b border-gray-200">
                        <!--                        <div class="flex flex-col font-medium text-gray-600">-->
                        <!--                            Товары-->
                        <!--                        </div>-->
                        <Link :href="route('compareProducts')" class="flex flex-col font-medium">
                            <div class="flex items-center justify-between">
                                <div>
                                    Сравнение товаров
                                </div>
                                <div class="flex items-center gap-2">
                                    <div v-if="isClient && compareStore.comparedIds.length"
                                         v-text="compareStore.comparedIds.length"
                                         class="flex items-center justify-center w-[16px] h-[16px]  bg-red-600 rounded-full text-xs font-semibold text-white">
                                    </div>
                                    <IconAngleLeft class="w-5 h-5 rotate-180"/>
                                </div>
                            </div>
                        </Link>
                        <Link :href="route('likedProducts')" class="flex flex-col font-medium">
                            <div class="flex items-center justify-between">
                                <div>
                                    Избранные товары
                                </div>
                                <div class="flex items-center gap-2">
                                    <div v-if="isClient && likeStore.likedIds.length"
                                         v-text="likeStore.likedIds.length"
                                         class="flex items-center justify-center w-[16px] h-[16px]  bg-red-600 rounded-full text-xs font-semibold text-white">
                                    </div>
                                    <IconAngleLeft class="w-5 h-5 rotate-180"/>
                                </div>
                            </div>
                        </Link>
                        <Link :href="route('cart')" class="flex flex-col font-medium">
                            <div class="flex items-center justify-between">
                                <div>
                                    Корзина
                                </div>
                                <div class="flex items-center gap-2">
                                    <div v-if="isClient && cartStore.items.length"
                                         v-text="cartStore.items.length"
                                         class="flex items-center justify-center w-[16px] h-[16px]  bg-red-600 rounded-full text-xs font-semibold text-white">
                                    </div>
                                    <IconAngleLeft class="w-5 h-5 rotate-180"/>
                                </div>
                            </div>
                        </Link>
                    </div>
                    <div class="flex flex-col gap-5 mt-8 pb-8 border-b border-gray-200">
                        <div class="flex flex-col font-medium text-gray-600">
                            B2B
                        </div>
                        <Link class="flex flex-col font-medium"
                              :href="route('B2BForBuilders')">
                            <div class="flex items-center justify-between">
                                <div>
                                    Девелоперам и застройщикам
                                </div>
                                <div class="flex items-center gap-2">
                                    <IconAngleLeft class="w-5 h-5 rotate-180"/>
                                </div>
                            </div>
                        </Link>
                        <Link class="flex flex-col font-medium"
                              :href="route('B2BForJBI')">
                            <div class="flex items-center justify-between">
                                <div>
                                    Производителям ЖБИ и Бетонным заводам
                                </div>
                                <div class="flex items-center gap-2">
                                    <IconAngleLeft class="w-5 h-5 rotate-180"/>
                                </div>
                            </div>
                        </Link>
                        <Link class="flex flex-col font-medium"
                              :href="route('B2BForLSTC')">
                            <div class="flex items-center justify-between">
                                <div>
                                    Производителям ЛСТК
                                </div>
                                <div class="flex items-center gap-2">
                                    <IconAngleLeft class="w-5 h-5 rotate-180"/>
                                </div>
                            </div>
                        </Link>
                        <Link class="flex flex-col font-medium"
                              :href="route('B2BForInstallationOrganizations')">
                            <div class="flex items-center justify-between">
                                <div>
                                    Монтажным организациям
                                </div>
                                <div class="flex items-center gap-2">
                                    <IconAngleLeft class="w-5 h-5 rotate-180"/>
                                </div>
                            </div>
                        </Link>
                        <Link class="flex flex-col font-medium"
                              :href="route('B2BForAgro')">
                            <div class="flex items-center justify-between">
                                <div>
                                    Сельхоз предприятиям
                                </div>
                                <div class="flex items-center gap-2">
                                    <IconAngleLeft class="w-5 h-5 rotate-180"/>
                                </div>
                            </div>
                        </Link>
                        <Link class="flex flex-col font-medium"
                              :href="route('B2BForWorkshops')">
                            <div class="flex items-center justify-between">
                                <div>
                                    Производительным цехам
                                </div>
                                <div class="flex items-center gap-2">
                                    <IconAngleLeft class="w-5 h-5 rotate-180"/>
                                </div>
                            </div>
                        </Link>
                    </div>
                    <div class="flex flex-col gap-5 mt-8 pb-8 border-b border-gray-200">
                        <div class="flex flex-col font-medium text-gray-600">
                            Информация
                        </div>
                        <Link :href="route('contacts')" class="flex flex-col font-medium">
                            <div class="flex items-center justify-between">
                                <div>
                                    Обратная связь
                                </div>
                                <div class="flex items-center gap-2">
                                    <IconAngleLeft class="w-5 h-5 rotate-180"/>
                                </div>
                            </div>
                        </Link>
                        <Link :href="route('aboutCompany')" class="flex flex-col font-medium">
                            <div class="flex items-center justify-between">
                                <div>
                                    О компании
                                </div>
                                <div class="flex items-center gap-2">
                                    <IconAngleLeft class="w-5 h-5 rotate-180"/>
                                </div>
                            </div>
                        </Link>
                        <Link :href="route('privacyPolicy')" class="flex flex-col font-medium">
                            <div class="flex items-center justify-between">
                                <div>
                                    Политики конфиденциальности
                                </div>
                                <div class="flex items-center gap-2">
                                    <IconAngleLeft class="w-5 h-5 rotate-180"/>
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        </div>

        <!-- Overlay -->
        <div v-if="menuStore.isProfileSidenavOpen"
             @click.prevent="menuStore.toggleProfileSidenav"
             class="fixed inset-0 bg-black bg-opacity-50 z-40"></div>
    </div>
</template>

<style scoped lang="scss">
.menu-chevron {
    line-height: 1.3;
}
</style>
